import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/Terms.css";
import Footerlanding from "../landing/Footerlanding";
import Navbarlanding from "../landing/Navbarlanding";
import { parse } from "tldts";

const TermsAndConditions = () => {
  const [company, setCompany] = useState({
    name: "Your Company",
    logo: "",
    favicon: "",
    domain: "",
    subdomain: "",
    email: "",
  });
  const [fetchError, setFetchError] = useState("");

  const getDomainInfo = () => {
    const hostname = window.location.hostname;
    const parsed = parse(hostname);
    return {
      domain: parsed.domainWithoutSuffix || "",
      subdomain: parsed.subdomain || "",
    };
  };

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const { domain } = getDomainInfo();
        const response = await axios.get("https://payyug.in/api/get-company", {
          params: { domain },
        });
        const data = response.data;

        if (data && Object.keys(data).length > 0) {
          setCompany((prev) => ({
            ...prev,
            name: data.name || prev.name,
            logo: data.logo || prev.logo,
            favicon: data.favicon || prev.favicon,
            domain: data.domain || prev.domain,
            subdomain: data.subdomain || prev.subdomain,
            email: data.email || prev.email,
          }));

          if (data.favicon) {
            const link =
              document.querySelector("link[rel*='icon']") ||
              document.createElement("link");
            link.type = "image/png";
            link.rel = "icon";
            link.href = `https://payyug.in/${
              data.favicon.startsWith("images/")
                ? data.favicon.slice(7)
                : data.favicon
            }`;
            document.head.appendChild(link);
          }
        } else {
          setFetchError("Company info not found.");
        }
      } catch (err) {
        console.error("Company fetch failed:", err);
        setFetchError("Failed to fetch company info.");
      }
    };

    fetchCompany();
  }, []);

  const contactEmail = company?.email || "contact@yourdomain.com";

  return (
    <div className="terms-page">
      <Navbarlanding />

      <div className="terms-wrapper">
        <h1>Terms &amp; Conditions – {company.name}</h1>
        <p className="last-updated">Effective Date: January 2026</p>

        {fetchError && <p className="error-text">{fetchError}</p>}

        <section>
          <p>
            Welcome to {company.name} ({company.domain || "yourdomain.com"}).
          </p>
          <p>
            These Terms &amp; Conditions (“Terms”) govern your access to and use of
            our website and loan management software platform. By applying for a loan or accessing
            our services, you agree to be bound by these Terms.
          </p>
          <p>
            If you do not agree with any part of these Terms, you must not use
            our services.
          </p>
        </section>

        <section>
          <h2>1. Definitions</h2>
          <p>
            <strong>“Platform”</strong> refers to the website{" "}
            {company.domain || "yourdomain.com"} and its digital micro-finance management tools.
            <br />
            <strong>“Borrower / User”</strong> refers to any individual or business applying for or managing a loan facility on the platform.
            <br />
            <strong>“{company.name}”, “we”, “our”, “us”</strong> refers to the operators of the loan software platform.
            <br />
            <strong>“Services”</strong> include digital loan processing, EMI tracking, credit evaluation, automated disbursement, and repayment facilitation.
          </p>
        </section>

        <section>
          <h2>2. Scope of Services</h2>
          <p>{company.name} is a micro-finance &amp; loan management software platform that provides:</p>
          <ul>
            <li>Digital processing for Personal Loans, Group Loans, Micro-Finance, and Small Business Loans</li>
            <li>Automated EMI scheduling, loan statement tracking, and repayment processing</li>
            <li>E-KYC integration and credit evaluation workflows</li>
            <li>Loan settlement, foreclosure, and clearance certificate facilitation</li>
          </ul>
          <p>
            All loan approvals, interest rates, and disbursals are subject to credit evaluations, documentation verification, and lender eligibility criteria.
          </p>
        </section>

        <section>
          <h2>3. Borrower Eligibility</h2>
          <p>To register or apply for credit facilities, you must:</p>
          <ul>
            <li>Be at least 18 years of age</li>
            <li>Possess valid government identification and verifiable income credentials</li>
            <li>Provide true, complete, and updated personal and financial details</li>
            <li>Possess legal capacity to execute enforceable loan agreements</li>
          </ul>
          <p>
            {company.name} reserves the right to reject applications or suspend access if eligibility requirements are unfulfilled.
          </p>
        </section>

        <section>
          <h2>4. Borrower Responsibilities</h2>
          <p>Borrowers agree to:</p>
          <ul>
            <li>Ensure timely payment of scheduled loan EMIs on or before due dates</li>
            <li>Maintain absolute secrecy of login PINs, passwords, and security credentials</li>
            <li>Notify {company.name} immediately in the event of suspected security compromises or profile misuse</li>
            <li>Utilize disbursed loan proceeds exclusively for lawful financial purposes</li>
          </ul>
          <p>
            {company.name} is not responsible for penalties or losses resulting from borrower negligence or delayed EMI repayments.
          </p>
        </section>

        <section>
          <h2>5. Account Security &amp; Misuse</h2>
          <ul>
            <li>Borrowers are fully liable for activities conducted through their registered account</li>
            <li>Sharing account access or credentials with third parties is strictly prohibited</li>
            <li>Accounts involved in fraudulent document submission or loan defaults may be suspended or escalated legally</li>
          </ul>
        </section>

        <section>
          <h2>6. Credit Approvals &amp; Disbursals</h2>
          <ul>
            <li>Submitting a loan application does not guarantee automatic sanction or disbursal</li>
            <li>Sanctioned amounts and repayment schedules are finalized post-verification</li>
            <li>Disbursal timelines are subject to banking hours, account verification, and partner clearance</li>
          </ul>
        </section>

        <section>
          <h2>7. Interest Rates, Processing Fees &amp; EMI Rules</h2>
          <ul>
            <li>Applicable interest rates, processing fees, and late payment penalties are explicitly disclosed prior to loan agreement signing</li>
            <li>Delayed EMI payments may incur late payment charges and negatively impact credit bureau scores</li>
          </ul>
        </section>

        {/* --- ADDED APPLICANT DECLARATION SECTION (HINDI & ENGLISH) --- */}
        <section className="declaration-section">
          <h2>8. Applicant Self-Declaration / आवेदक स्व-घोषणा</h2>
          
          <div className="declaration-block hindi-declaration">
            <h3>आवेदक की घोषणा</h3>
            <p>
              मैं, <strong>[आवेदक का नाम]</strong>, यह घोषणा करता/करती हूँ कि मैंने <strong>{company.name}</strong> से प्राप्त वित्तीय सहायता राशि अपनी पूर्ण स्वेच्छा से स्वीकार की है।
            </p>
            <ul>
              <li>मैंने संस्था द्वारा बताई गई सभी नियम एवं शर्तों को पढ़ लिया है, समझ लिया है और उन्हें स्वीकार करता/करती हूँ।</li>
              <li>मुझे सहायता राशि, पुनर्भुगतान (Repayment) की शर्तें, Service Charge (यदि लागू हो) तथा अन्य लागू शुल्कों की जानकारी राशि प्राप्त करने से पहले दे दी गई है।</li>
              <li>मैं निर्धारित पुनर्भुगतान अनुसूची के अनुसार समय पर देय राशि का भुगतान करने के लिए सहमत हूँ।</li>
              <li>मेरे द्वारा दिए गए सभी दस्तावेज़ एवं जानकारी सही, सत्य एवं पूर्ण हैं। किसी भी जानकारी के गलत पाए जाने पर संस्था आवश्यक कार्रवाई कर सकती है।</li>
              <li>मैं यह स्वीकार करता/करती हूँ कि यह आवेदन और राशि प्राप्ति मेरी पूर्ण स्वेच्छा से हुई है। मुझ पर किसी भी प्रकार का दबाव, प्रलोभन या बल प्रयोग नहीं किया गया है।</li>
              <li>मैं समझता/समझती हूँ कि संस्था के संचालन, दस्तावेज़ सत्यापन, स्टाफ, तकनीकी सेवाओं, फील्ड कार्य एवं प्रशासनिक व्ययों की पूर्ति के लिए संस्था अपनी घोषित नीति के अनुसार Service Charge ले सकती है।</li>
              <li>मैं समय पर भुगतान न होने की स्थिति में संस्था द्वारा अनुबंध एवं लागू कानूनों के अनुसार की जाने वाली कार्रवाई को स्वीकार करता/करती हूँ।</li>
              <li>मैं अपने मोबाइल नंबर, पता, बैंक विवरण या अन्य आवश्यक जानकारी में किसी भी परिवर्तन की सूचना संस्था को दूँगा/दूँगी।</li>
              <li>मैं यह घोषणा करता/करती हूँ कि मैंने किसी भी प्रकार के भ्रम, दबाव या गलत जानकारी के आधार पर यह आवेदन नहीं किया है।</li>
            </ul>
            <p className="consent-text">
              <strong>"I Agree"</strong> पर क्लिक करना, OTP सत्यापन करना या हस्ताक्षर करना मेरी स्वैच्छिक एवं सूचित सहमति का प्रमाण माना जाएगा।
            </p>
          </div>

          <div className="declaration-block english-declaration">
            <h3>Applicant's Declaration</h3>
            <p>
              I, <strong>[Applicant's Name]</strong>, hereby declare that I have accepted the financial assistance received from <strong>{company.name}</strong> out of my own free will.
            </p>
            <ul>
              <li>I have read, understood, and accepted all the terms and conditions outlined by the organization.</li>
              <li>I have been informed of the assistance amount, repayment terms, Service Charges (if applicable), and other applicable fees prior to receiving the funds.</li>
              <li>I agree to pay the due amount on time according to the scheduled repayment timeline.</li>
              <li>All documents and information provided by me are true, accurate, and complete. If any information is found false, the organization reserves the right to take necessary action.</li>
              <li>I confirm that this application and acceptance of funds are entirely voluntary, made without any pressure, coercion, or undue inducement.</li>
              <li>I understand that the organization may charge a Service Charge in accordance with its declared policies to cover operations, document verification, staff, technical services, field work, and administrative expenses.</li>
              <li>In the event of delayed payment, I accept any lawful action taken by the organization as per the contract and applicable regulations.</li>
              <li>I undertake to notify the organization immediately of any changes to my mobile number, address, bank details, or other essential information.</li>
              <li>I declare that I have not submitted this application under any ambiguity, pressure, or misrepresentation.</li>
            </ul>
            <p className="consent-text">
              Clicking <strong>"I Agree"</strong>, completing OTP verification, or submitting a signature shall be considered proof of my voluntary and informed consent.
            </p>
          </div>
        </section>

        <section>
          <h2>9. Intellectual Property</h2>
          <p>
            All content on {company.domain || "yourdomain.com"}, including credit algorithms, loan calculators, software source code, and branding, is the exclusive intellectual property of{" "}
            {company.name}. Unsanctioned copying or reverse engineering is strictly prohibited.
          </p>
        </section>

        <section>
          <h2>10. Prohibited Conduct</h2>
          <p>Users are forbidden from:</p>
          <ul>
            <li>Submitting forged income proofs, altered IDs, or misleading credit details</li>
            <li>Attempting unauthorized access to loan management backend systems</li>
            <li>Bypassing automated EMI payment routines or system controls</li>
          </ul>
        </section>

        <section>
          <h2>11. Limitation of Liability</h2>
          <p>{company.name} shall not be held liable for:</p>
          <ul>
            <li>Rejections or delays in loan approvals resulting from failed credit checks</li>
            <li>System outages or payment gateway delays impacting immediate EMI reflection</li>
            <li>Indirect damages arising from default actions taken by partner lenders</li>
          </ul>
        </section>

        <section>
          <h2>12. Third-Party Integrations</h2>
          <p>
            The platform relies on third-party verification networks, credit bureaus, and payment gateways. We do not assume responsibility for external service outages.
          </p>
        </section>

        <section>
          <h2>13. Account Termination &amp; Loan Default</h2>
          <p>
            {company.name} reserves the right to suspend platform access for borrowers who breach these Terms or default on loan repayment obligations.
          </p>
        </section>

        <section>
          <h2>14. Governing Law</h2>
          <p>
            These Terms are governed by and construed in accordance with the laws of India. Any legal disputes shall fall under the exclusive jurisdiction of competent Indian courts.
          </p>
        </section>

        <section>
          <h2>15. Amendments</h2>
          <p>
            {company.name} may modify these Terms at any time. Continued usage of the platform after policy revisions constitutes acceptance of revised terms.
          </p>
        </section>

        <section>
          <h2>16. Contact Information</h2>
          <p>
            For questions regarding loan agreements, EMI policies, or these Terms, contact:
          </p>
          <p>
            📧 <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
          </p>
        </section>

        <section>
          <h2>Disclaimer</h2>
          <p>
            {company.name} is a digital loan software platform. Loan disbursals, interest rates, and repayment terms are governed by verified credit agreements and lender partner guidelines.
          </p>
        </section>
      </div>

      <Footerlanding />
    </div>
  );
};

export default TermsAndConditions;